import palette from "./palette"

const headerFontFamilies = ["'Ubuntu'", "Helvetica Neue", "sans-serif"].join(
  ","
)

export default {
  fontFamily: ["'Roboto'", "Helvetica Neue", "sans-serif"].join(","),
  h1: {
    fontFamily: headerFontFamilies,
    color: palette.text.primary,
    fontWeight: "500",
    fontSize: "35px",
    letterSpacing: "-0.24px",
    lineHeight: "40px",
  },
  h2: {
    fontFamily: headerFontFamilies,
    color: palette.text.primary,
    fontWeight: "500",
    fontSize: "29px",
    letterSpacing: "-0.24px",
    lineHeight: "32px",
  },
  h3: {
    fontFamily: headerFontFamilies,
    color: palette.text.primary,
    fontWeight: "500",
    fontSize: "24px",
    letterSpacing: "-0.06px",
    lineHeight: "28px",
  },
  h4: {
    fontFamily: headerFontFamilies,
    color: palette.text.primary,
    fontWeight: "500",
    fontSize: "20px",
    letterSpacing: "-0.06px",
    lineHeight: "24px",
  },
  h5: {
    fontFamily: headerFontFamilies,
    color: palette.text.primary,
    fontWeight: "500",
    fontSize: "16px",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
  },
  h6: {
    fontFamily: headerFontFamilies,
    color: palette.text.primary,
    fontWeight: "500",
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: "18px",
    letterSpacing: "-0.05px",
    lineHeight: "25px",
  },
  subtitle2: {
    color: palette.text.primary,
    fontSize: "16px",
    letterSpacing: 0,
    lineHeight: "20px",
  },
  body1: {
    color: palette.text.primary,
    fontSize: "18px",
    letterSpacing: "-0.05px",
    lineHeight: "23px",
  },
  body2: {
    color: palette.text.primary,
    fontSize: "16px",
    letterSpacing: "-0.04px",
    lineHeight: "20px",
  },
  button: {
    color: palette.text.primary,
    fontSize: "16px",
  },
  caption: {
    color: palette.text.secondary,
    fontSize: "14px",
    letterSpacing: "0.3px",
    lineHeight: "18px",
  },
}
